import { ValueGetterParams } from '@ag-grid-enterprise/all-modules';
import { AuditConfiguration } from './auditConfiguration.types';

export const auditStatus = (data: AuditConfiguration): string => {
  const {
    result = '',
  } = data as AuditConfiguration;

  const status = result === '200 OK';

  let value = 'STATUS';

  if (status) {
    value = '200 OK';
  } else {
    value = 'FAILED';
  }

  return value;
};

export const auditValueGetter = ({ data }: ValueGetterParams): string => {
  return auditStatus(data);
};

export default auditValueGetter;
